module.exports = __webpack_public_path__ + "img/cursive-workbook_B09918LTNS.766bdbdf.jpg";